// extracted by mini-css-extract-plugin
module.exports = {"entity":"Entity_entity__3_6rj","gridContainer":"Entity_gridContainer__2a27S","icon":"Entity_icon__17IIq","content":"Entity_content__Q2w9M","value":"Entity_value__21wpB"};